// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Search_searchBar__1aJGO","searchIcon":"Search_searchIcon__1ZsTC","addRecipeContainer":"Search_addRecipeContainer__3QWXn","Link":"Search_Link__3yMdQ"};